import React, { useEffect, useState } from "react";
import { Checkbox } from "antd";
import { useIntl } from "react-intl";
import { getEmployeeOncallUsage } from "../../api/server";
import moment from "moment";
const OncallSelector = (props) => {
  const { onOncallChange, activeEvent, readonly } = props;
  const [oncallData, setOncallData] = useState(null);
  const intl = useIntl();

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        from: moment(activeEvent.date).startOf("month").format(),
        to: moment(activeEvent.date).endOf("month").format(),
        employeeId: activeEvent.employee_id,
      };
      const action = await getEmployeeOncallUsage(params);
      setOncallData(action?.data);
    };
    if (!readonly && activeEvent?.date) {
      fetchData().catch(console.error);
    }
    return () => {
      setOncallData(null);
    };
  }, [activeEvent]);

  const hasOncallLeft = oncallData?.oncall_total > oncallData?.oncall_used;

  return (
    activeEvent?.employee?.oncall && (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Checkbox
          onChange={(e) => onOncallChange(e.target.checked)}
          checked={activeEvent.oncall}
          disabled={readonly || (!hasOncallLeft && !activeEvent.oncall)}
        >
          {intl.formatMessage({
            id: "app.scheduling.oncall",
          })}
        </Checkbox>
      </div>
    )
  );
};

export default OncallSelector;
